import delay from 'delay';
import { useCurrentUserIguanaObject } from 'FrontRoyalAngular';
import { useSuspendableResource } from 'useSuspendableResource';

export function useContentProgress() {
    const currentUser = useCurrentUserIguanaObject();
    if (!currentUser) throw delay(100);
    return useSuspendableResource(currentUser.progress.suspendableResource);
}
